import React, { useState } from 'react';
import { Button, Modal, Table, Card, Form, Row, Col, Breadcrumb } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Link } from "react-router-dom";
import { ToastContainer, toast} from 'react-toastify';
import axios from "axios";
import {OutTable, ExcelRenderer} from 'react-excel-renderer';
import "react-table/react-table.css"; 
import _ from "lodash";
import Select from 'react-select';
import ReactTable from "react-table";
import { map,omit } from 'lodash/fp';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import "./fileupload.css";
import uploadImg from './images/cloud-upload-regular-240.png';
import { ImageConfig } from './ImageConfig'; 
import Icon from '@material-ui/core/Icon';
//const configData= require('config');
const configData = require( '../../config.json');
var convertarray=(array)=>{
  
  var first = array[0];//.rows[0].join('|')
          var headers = first;//.split('|');
           
          var jsonData = [];

          for ( var i = 1, length = array.length; i < length; i++ )
          {
        
            var myRow = array[i];//.join('|');
            var row = myRow;//.split('|');
            // row.push('total');
            var data = {};
            for ( var x = 0; x < row.length; x++ )
            {
              if(headers[x]=="startdate" ||headers[x]=="enddate" ||headers[x]=="start_date" ||headers[x]=="end_date"){
                data[headers[x]] = row[x].length>0? this.ExcelDateToJSDate(row[x]):'';
              }
              else{
                data[headers[x]] = row[x];
              }
            }
           
            jsonData.push(data);
           // array.rows[i][10]=1000;
          }
          var total=0;
          for (i = 0; i < jsonData.length; i++) {  //loop through the array
            total += parseFloat( jsonData[i].activitylevel);  //Do the math!
          }
          return jsonData;
}
const fileType =
"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

const fileExtension = ".xlsx";
 
export default class FileUpload extends React.Component  {
    constructor(...args) {
        super(...args)
          
        this.state={
          selectedFile: [],
          orgname:'',
          fileValidationOrgId:'',
          verifiedFilePath:'',
          loginname:'',
          filetype:null,
          file_type:null,
          fileStructureName:null,
          fileStructureNames:[],
          fileuploaddetails:[],
          columns:[],
          userrole:{create:''}          
       }
         
          this.onChangeHandler = this.onChangeHandler.bind(this);
        this.fileInput = React.createRef();
        this.setState({Labels:[],  isFetching: true});       
        this.fetchLabelMessagesAPI();        
    }
    componentDidMount() {
      this.fetchFileUploadDetails();
      this.getColumns();
  }

    getColumns = () => {
      var rolelist= JSON.parse(localStorage.getItem("rolelocation"));      
      var primaryroleval=  localStorage.getItem("primaryrolesession");
      var selectedrolelocation=undefined;
      _.forEach(rolelist, function(value) {
           
          if(primaryroleval==value.name){
              selectedrolelocation=value;
          }
          
      });
     
      var userrl =_.find(selectedrolelocation.location, function(obj) {
          return obj.location === 'FileUpload';
      });
      let columns = [
        {
          Header: "File Name",
            accessor: "filename",
          sortable: true,
          show: true,
          displayValue: "File Name"        
          
        },
        {
          Header: "File Type",
          accessor: "filetype",
          sortable: true,
          show: true,
          displayValue: "File Type"
          
        },
        {
          Header: "File Location",
          accessor: "path",
          sortable: true,
          show: true,
          displayValue: "File Location"
          
        },        
        {
          Header: "File Status",
          accessor: "status",
          sortable: true,
          show: true,
          displayValue: "File Status"
          
        },
        {
          Header: "Uploaded By",
          accessor: "createby",
          sortable: true,
          show: true,
          displayValue: "Uploaded By"
          
        },  
        {
          Header: "Uploaded Date",
          accessor: "createdt",
          sortable: true,
          show: true,
          displayValue: "Uploaded Date"
          
        },
        {
          Header:"Delete",
          maxWidth: 100,
          minWidth: 58,
          width: 58,
          show:userrl.delete=='Y'?true:false,
          Cell:row => (<div className="grdbuttoncontainer"><div className="deletecontainer"> <a
              className="deletebutton"
              aria-label="Delete"
              onClick={(event) => this.handleDeleteClick(row,event)}
          >
              <i className="">
                  <img
                      alt="Delete"
                      className=""
                      src="/images/delete_icon.png"
                  />
              </i>
          </a></div></div>)
        }   
       
      ];
      this.setState({ columns });
    };


  handleChange = e => {
      
    let { value, name } = e.target;    
        
         this.setState({...this.state,filetype:value});      
        
};


fetchLabelMessagesAPI = () => {
  this.setState({...this.state, isFetching: true});
  
  axios
  .get(configData.SERVER_URL+`fincorp_getCustomMessage` 
  , {
      headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*"
      }
  })
  .then(
      res=>  {this.setBindMessage(res.data) }
  )
  .catch(err => {
      console.log("AXIOS ERROR: ", err);
  });
};

//refer INC018
setBindMessage = (result) => {

  var session = localStorage.getItem("session");
  var userlogin = JSON.parse(session);

  var fullorgname = userlogin.Result[0].org;
  var n = fullorgname.lastIndexOf("/");
  var org = fullorgname.substring(n + 1, fullorgname.length);

  this.setState({
      Labels: result != null ? result : [],
      orgname: org,
      loginname: userlogin.Result[0].login,
      isFetching: false
  }, () => {

      // Get the organization ID required by File Validation API
      fetch(configData.FILEVALIDATION_URL + 'get_organizations')
          .then(response => response.json())
          .then(organizations => {

              console.log("File Validation organizations:", organizations);
              console.log("Current organization:", fullorgname);

              const matchedOrganization = organizations.find(
                  item => item[0] === fullorgname
              );

              if (matchedOrganization) {

                  const orgId = matchedOrganization[1];

                  console.log("File Validation Org ID:", orgId);

                  this.setState({
                      ...this.state,
                      fileValidationOrgId: orgId
                  }, () => {
                      this.fetchFileType();
                  });

              } else {

                  console.error(
                      "Organization not found in File Validation:",
                      fullorgname
                  );

                  this.setState({
                      ...this.state,
                      fileValidationOrgId: '',
                      filetypes: []
                  });

              }
          })
          .catch(error => {
              console.error(
                  "Error fetching File Validation organizations:",
                  error
              );

              this.setState({
                  ...this.state,
                  fileValidationOrgId: '',
                  filetypes: []
              });
          });
  });
}//refer INC018

onChangeHandler=event=>{

var arrayList=this.state.selectedFile;
for (let i = 0; i < event.target.files.length; i++) {
 
 
arrayList.push(event.target.files[i])
}
 this.setState({...this.state,
    selectedFile: arrayList,
    loaded: 0,
  })
}

// .then(res => { // then print response status
//   console.log(res.statusText)
// })
// }

fetchFileType = () => {

  console.log("Organization being sent:", this.state.orgname);

  this.setState({...this.state, isFetching: true});

  fetch(
      configData.FILEVALIDATION_URL +
      'get_filetypes?Organization=' +
      encodeURIComponent(this.state.fileValidationOrgId)
  )
  .then(response => {
      console.log("File Type API status:", response.status);
      return response.json();
  })
  .then(result => {

      console.log("File Type API result:", result);

      if (
          result !== 'No document(s) found with defined find criteria!' &&
          result.length > 0
      ) {
          const fileTypeOptions = result.map(fileType => ({
              label: fileType,
              value: fileType
          }));

          this.setState({
              ...this.state,
              filetypes: fileTypeOptions,
              isFetching: false
          });

      } else {
          this.setState({
              ...this.state,
              filetypes: [],
              fileStructureNames: [],
              isFetching: false
          });
      }
  })
  .catch(e => {
      console.log("File Type API ERROR:", e);
      this.setState({...this.state, isFetching: false});
  });
};//code change because of INC018

bindFileType=(result)=>{
  if(result!='No document(s) found with defined find criteria!' && result.length>0)
  {
      
       this.setState({...this.state,filetypes: result, isFetching: false})
       
  }
  else
  {
       
    this.setState({...this.state,filetypes: [], isFetching: false})
  }
   
}

fetchFileStructureNames = (fileType) => {

  if (!fileType || !fileType.value) {
      this.setState({
          ...this.state,
          fileStructureNames: [],
          fileStructureName: null
      });
      return;
  }

  console.log("Fetching structure names for:", fileType.value);
  console.log(
      "File Validation Org ID:",
      this.state.fileValidationOrgId
  );

  fetch(
      configData.FILEVALIDATION_URL +
      'filterdata?company=' +
      encodeURIComponent(this.state.fileValidationOrgId) +
      '&fileType=' +
      encodeURIComponent(fileType.value) +
      '&fileStructureName=' +
      '&fileFrequency=' +
      '&mailId='
  )
  .then(response => {
      console.log("Structure API status:", response.status);
      return response.json();
  })
  .then(result => {

      console.log("Structure API result:", result);

      if (
          result &&
          result !== 'No document(s) found with defined find criteria!'
      ) {

          const structureNames = [];

          result.forEach(item => {

              if (item.fileStructureName) {

                  structureNames.push({
                      label: item.fileStructureName,
                      value: item.fileStructureName
                  });

              }

          });

          this.setState({
              ...this.state,
              fileStructureNames: structureNames,
              fileStructureName: null
          });

      } else {

          this.setState({
              ...this.state,
              fileStructureNames: [],
              fileStructureName: null
          });

      }

  })
  .catch(error => {

      console.error(
          "Error fetching file structure names:",
          error
      );

      this.setState({
          ...this.state,
          fileStructureNames: [],
          fileStructureName: null
      });

  });
};

fetchVerifiedFilePath = (fileType) => {
  if (!fileType || !fileType.value || !this.state.fileValidationOrgId) {
    this.setState({
      ...this.state,
      verifiedFilePath: ''
    });
    return;
  }

  console.log("Fetching Verified Files Directory for:", fileType.value);
  console.log("File Validation Org ID:", this.state.fileValidationOrgId);

  fetch(
    configData.SERVER_URL +
    'fincorp_getLookupValueBasedOnOrgIdAndObjectType?orgid=' +
    encodeURIComponent(this.state.fileValidationOrgId) +
    '&object_type=' +
    encodeURIComponent(fileType.value)
  )
    .then(response => {
      console.log("Lookup API status:", response.status);
      return response.json();
    })
    .then(result => {
      console.log("Lookup API result:", result);

      if (!Array.isArray(result)) {
        console.error("Lookup API did not return an array:", result);

        this.setState({
          ...this.state,
          verifiedFilePath: ''
        });

        return;
      }

      const verifiedDirectory = result.find(
        item => item.lookup_name === "Verified Files Directory"
      );

      if (!verifiedDirectory) {
        console.error(
          "Verified Files Directory lookup not found for:",
          fileType.value
        );

        toast.error(
          '"Verified Files Directory" Lookup Value has not been set up for this File Type'
        );

        this.setState({
          ...this.state,
          verifiedFilePath: ''
        });

        return;
      }

      let verifiedPath = verifiedDirectory.lookup_value;

      // lookup_value is normally stored as an object with a label
      if (
        verifiedPath &&
        typeof verifiedPath === "object" &&
        verifiedPath.label
      ) {
        verifiedPath = verifiedPath.label;
      }

      console.log("Verified Files Directory:", verifiedPath);

      this.setState({
        ...this.state,
        verifiedFilePath: verifiedPath
      });
    })
    .catch(error => {
      console.error("Error fetching Verified Files Directory:", error);

      this.setState({
        ...this.state,
        verifiedFilePath: ''
      });

      toast.error("Failed to fetch Verified Files Directory.");
    });
};// refer INC018

handleFileTypeSelectChange = selectedOption => {

  this.setState({
    ...this.state,
    file_type: selectedOption,
    fileStructureName: null,
    fileStructureNames: [],
    verifiedFilePath: '',
    isFetching: false
  }, () => {

    this.fetchFileStructureNames(selectedOption);

    this.fetchVerifiedFilePath(selectedOption);

  });

}//refer INC018

fetchFileUploadDetails = () => {        
  this.setState({...this.state, isFetching: true});
  fetch(configData.SERVER_URL+'fincorp_getFileUploadDetailsList')
      .then(response => response.json())
      .then(result => {
           this.bindFileUploadDetails(result)
      })
      .catch(e => {
          console.log(e);
          this.setState({...this.state, isFetching: false});
      });
};
bindFileUploadDetails=(result)=>{

  if(result!='No document(s) found with defined find criteria!' && result.length>0)
  {
    var session=  localStorage.getItem("session");
        
    var userlogin=JSON.parse(session);
    var fullorgname=userlogin.Result[0].org;
    var n=fullorgname.lastIndexOf("/");
    var org=fullorgname.substring(n+1,fullorgname.length)
    
    var newArray = result.filter(function(item) {
      return item.orgname==org;
    });
    
       this.setState({...this.state,fileuploaddetails: newArray, isFetching: false})
  }
  else
  {
       
      this.setState({fileuploaddetails: [], isFetching: false})
  }
   
}

 fileRemove = (file) => {
 
  const updatedList = this.state.selectedFile;
  updatedList.splice(this.state.selectedFile.indexOf(file), 1);

  this.setState({...this.state,selectedFile: updatedList, isFetching: false})
}

validateSelectedFiles = async () => {
  const structureName = this.state.fileStructureName
    ? this.state.fileStructureName.value
    : '';

  if (!structureName) {
    toast.warn("Select File Structure Name");
    return false;
  }

  const selectedFiles = this.state.selectedFile || [];

  if (selectedFiles.length === 0) {
    toast.warn("Choose File");
    return false;
  }

  try {

    // -------------------------------------------------
    // 1. Validate filename
    // -------------------------------------------------
    for (let i = 0; i < selectedFiles.length; i++) {

      const filename = selectedFiles[i].name;

      // Remove the file extension
      const filenameWithoutExtension = filename.substring(
        0,
        filename.lastIndexOf(".")
      );
      
      // Check only whether the filename starts with
      // the selected File Structure Name
      if (!filenameWithoutExtension.startsWith(structureName)) {
      
        toast.error(
          "Invalid file name: " + filename +
          ". File name must start with " + structureName
        );
      
        return false;
      }
    }


    // -------------------------------------------------
    // 2. Get validation rules from File Validation API
    // -------------------------------------------------
    const url =
      configData.FILEVALIDATION_URL +
      'getlocalfileformatjson?company=' +
      encodeURIComponent(this.state.fileValidationOrgId) +
      '&fileType=' +
      encodeURIComponent(this.state.file_type.value) +
      '&fileStructureName=' +
      encodeURIComponent(structureName) +
      '&fileFrequency=' +
      '&mailId=';

    console.log("Validation API URL:", url);

    const response = await fetch(url);

    if (!response.ok) {
      toast.error("Unable to get file validation rules.");
      return false;
    }

    const validationRules = await response.json();

    console.log("Validation Rules:", validationRules);


    // -------------------------------------------------
    // 3. Get rules for selected File Structure Name
    // -------------------------------------------------
    const structureRules = validationRules[structureName];

    if (!structureRules) {
      toast.error(
        "No validation rules found for " + structureName
      );
      return false;
    }


    // Convert:
    // {
    //   "0": {...},
    //   "1": {...}
    // }
    // into an ordered array
    const rules = Object.keys(structureRules)
      .sort((a, b) => Number(a) - Number(b))
      .map(key => structureRules[key]);

    console.log("Parsed validation rules:", rules);


    // -------------------------------------------------
    // 4. Validate every selected file
    // -------------------------------------------------
    for (let fileIndex = 0; fileIndex < selectedFiles.length; fileIndex++) {

      const file = selectedFiles[fileIndex];

      const extension = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();

      if (extension !== ".xlsx" && extension !== ".csv") {
        toast.error(
          "Invalid file type: " + file.name +
          ". Only CSV and XLSX files are supported."
        );
        return false;
      }


      // -------------------------------------------------
      // 5. Read CSV/XLSX
      // -------------------------------------------------
      const fileData = await new Promise((resolve, reject) => {

        const reader = new FileReader();

        reader.onload = event => {

          try {

            const data = new Uint8Array(event.target.result);

            const workbook = XLSX.read(data, {
              type: "array"
            });

            const firstSheetName = workbook.SheetNames[0];

            const worksheet = workbook.Sheets[firstSheetName];

            const rows = XLSX.utils.sheet_to_json(
              worksheet,
              {
                header: 1,
                defval: ""
              }
            );

            resolve(rows);

          } catch (error) {
            reject(error);
          }

        };

        reader.onerror = error => reject(error);

        reader.readAsArrayBuffer(file);
      });


      console.log(
        "File data for " + file.name + ":",
        fileData
      );


      if (!fileData || fileData.length === 0) {
        toast.error(
          "File is empty: " + file.name
        );
        return false;
      }


      // -------------------------------------------------
      // 6. Validate column names
      // -------------------------------------------------
      const headers = fileData[0];

      if (!headers || headers.length !== rules.length) {
        toast.error(
          "Invalid columns in " + file.name +
          ". Expected " + rules.length +
          " columns."
        );
        return false;
      }


      for (let i = 0; i < rules.length; i++) {

        const expectedTitle = rules[i].Title;
        const actualTitle = headers[i];

        if (
          actualTitle === undefined ||
          String(actualTitle).trim() !== String(expectedTitle).trim()
        ) {

          toast.error(
            "Invalid column in " + file.name +
            ". Expected '" + expectedTitle +
            "' in column " + (i + 1) +
            " but found '" + actualTitle + "'."
          );

          return false;
        }
      }


      // -------------------------------------------------
      // 7. Validate data types
      // -------------------------------------------------
      for (let rowIndex = 1; rowIndex < fileData.length; rowIndex++) {

        const row = fileData[rowIndex];

        for (let columnIndex = 0; columnIndex < rules.length; columnIndex++) {

          const rule = rules[columnIndex];

          const value = row[columnIndex];

          // Ignore completely empty rows
          if (
            row.every(cell =>
              cell === undefined ||
              cell === null ||
              String(cell).trim() === ""
            )
          ) {
            continue;
          }


          // -----------------------------
          // StandardDate
          // -----------------------------
          if (rule.Type === "StandardDate") {

            const dateValue = String(value).trim();
        
            // Accept separators such as / - .
            const parts = dateValue.split(/[\/\-.]/);
        
            if (parts.length !== 3) {
        
                toast.error(
                    "Invalid date in " + file.name +
                    " at row " + (rowIndex + 1) +
                    ", column '" + rule.Title +
                    "'. Expected a valid date."
                );
        
                return false;
            }
        
            let month;
            let day;
            let year;
        
            // YYYY-MM-DD / YYYY/MM/DD / YYYY.MM.DD
            if (parts[0].length === 4) {
        
                year = Number(parts[0]);
                month = Number(parts[1]);
                day = Number(parts[2]);
        
            }
            // MM-DD-YYYY / MM/DD/YYYY / MM.DD.YYYY
            else {
        
                month = Number(parts[0]);
                day = Number(parts[1]);
                year = Number(parts[2]);
            }
        
            // Check that the numbers are actually valid
            const dateObject = new Date(year, month - 1, day);
        
            const isValidDate =
                year >= 1000 &&
                year <= 9999 &&
                month >= 1 &&
                month <= 12 &&
                day >= 1 &&
                day <= 31 &&
                dateObject.getFullYear() === year &&
                dateObject.getMonth() === month - 1 &&
                dateObject.getDate() === day;
        
            if (!isValidDate) {
        
                toast.error(
                    "Invalid date in " + file.name +
                    " at row " + (rowIndex + 1) +
                    ", column '" + rule.Title + "'."
                );
        
                return false;
            }
        }


          // -----------------------------
          // Text
          // -----------------------------
          else if (rule.Type === "Text") {

            if (
              value !== undefined &&
              value !== null &&
              value !== "" &&
              typeof value !== "string"
            ) {

              toast.error(
                "Invalid text value in " + file.name +
                " at row " + (rowIndex + 1) +
                ", column '" + rule.Title + "'."
              );

              return false;
            }
          }


          // -----------------------------
          // Int
          // -----------------------------
          else if (rule.Type === "Int") {

            if (
              value === undefined ||
              value === null ||
              String(value).trim() === "" ||
              !/^-?\d+$/.test(String(value).trim())
            ) {

              toast.error(
                "Invalid integer in " + file.name +
                " at row " + (rowIndex + 1) +
                ", column '" + rule.Title + "'."
              );

              return false;
            }
          }

        }
      }
    }

    console.log("All file validation checks passed.");

    return true;

  } catch (error) {

    console.error("FILE VALIDATION ERROR:", error);

    toast.error(
      "Unable to validate the file. Please check the file."
    );

    return false;
  }
};//refer INC018

onClickHandler = async (event) => {

  console.log(this.state.file_type,'file_type');
 
  if(this.state.file_type==undefined || this.state.file_type.label ==undefined || this.state.file_type.label ==""){
    toast.warn("Select File Type");
     event.preventDefault();            
    } 

  else if(this.state.selectedFile ==undefined || this.state.selectedFile.length==0){
    toast.warn("Choose File");
     event.preventDefault();        
    }
         

    else {

      const isValid = await this.validateSelectedFiles();
    
      if (!isValid) {
        event.preventDefault();
        return;
      }
 
  
        console.log(this.state.selectedFile.name);
        var bodyFormData = new FormData();
        for(var i=0;i<this.state.selectedFile.length;i++){
        bodyFormData.append('files', this.state.selectedFile[i]);
      }
var filenames='';
for(var i=0;i<this.state.selectedFile.length;i++){
  filenames=filenames+ this.state.selectedFile[i].name+'~';
}
  const config = {     
    headers: { 'content-type': 'multipart/form-data',
     }
}
axios({
  method: "post",
  url: configData.SERVER_URL+`fincorp_insertFileUpload`,
  data: bodyFormData,
  headers: { "Content-Type": "multipart/form-data","Authorization":this.state.orgname+'|'+filenames+'|'+this.state.verifiedFilePath
  },//refer INC018
})
  .then(response => {
    // For file already exist
    if(response.data.returnval!=null && response.data.returnval==-1){
      var comments='';
      
      for(var ob=0;ob<response.data.existingfiles.length;ob++){
        comments=comments+response.data.existingfiles[ob].filename+',';
      }
      toast.warn("File Already Exists "+comments);
    }else{    
   
    
    console.log(filenames);
    for(var i=0;i<this.state.selectedFile.length;i++){
      var filedetail={};
   
    filedetail.path=response.data.filepath+this.state.selectedFile[i].name;
    filedetail.filename=this.state.selectedFile[i].name;
    filedetail.filetype=this.state.file_type.label;
    filedetail.orgname=this.state.orgname;
    filedetail.status=response.data.status;
    filedetail.createdt=response.data.createdt;
    filedetail.createby=this.state.loginname;
    filedetail.moved='N';
    
  
    axios.post(configData.SERVER_URL+`fincorp_insertFileUploadDetails`, filedetail, {  })
    .then(res => { // then print response status
        
      toast.success("File Uploaded Successfully");
      this.fetchFileUploadDetails();
      this.setState({...this.state,selectedFile: [], isFetching: false})
    })
    }
   } // file already exist ends
   
  })
  .catch(error => {
      console.error("FILE UPLOAD ERROR:", error);

      if (error.response) {
          console.error("Upload API status:", error.response.status);
          console.error("Upload API response:", error.response.data);
      }

      toast.error("File upload failed. Please check the file and try again.");
  });
    
}//refer INC018
}

handleDeleteClick=(row,event)=>{
  if(window.confirm('Are you sure to delete this record?')){           
      if(row.original._id!=undefined){
          axios
          .post(configData.SERVER_URL+`fincorp_deleteUploadFileReference`,
          
          {'_id': row.original._id}
          , {
              headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                  "Access-Control-Allow-Origin": "*"
              }
          })
          .then(
              res => this.reloadDataGrid(res.data)
              
          )
          .catch(err => {
              console.log("AXIOS ERROR: ", err);
          });
      // event.preventDefault();
      }
      else{
          //error            
          toast.warn("File Reference Not Deleted");
      }
  }
}
reloadDataGrid=(res)=>{       
        
  toast.success("File Reference Delete Successfully");
  setTimeout( this.fetchFileUploadDetails(),4000);
}

insertfileuploaddetails=(filepath,status,createdt)=>{
  
 
}
  render() {
        const Labels=this.state.Labels!=null&& this.state.Labels!=undefined?this.state.Labels:[];
        const optionsArray =this.state.filetypes!=null&& this.state.filetypes!=undefined? this.state.filetypes:[];  
        const fileList= this.state.selectedFile!=null&& this.state.selectedFile!=undefined?this.state.selectedFile:[];       
        return (
        <>
         {/* <ToastContainer autoClose={false} />  */}
            <div className="container userinfo-container fileuploadlist" role="main">
                <Breadcrumb>
                    <Breadcrumb.Item>
                        <Link to="/Home">Home </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>
                    {Labels.filter(lbl => lbl.keyPair=='FileUpload_Title' && lbl.pageName=='FileUpload').map(filteredPerson => (
                        <span>
                        {filteredPerson.keyValue}
                        </span>
                    ))}
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div className="centeralign">
                    <span className="mainheadings">
                    {Labels.filter(lbl => lbl.keyPair=='FileUpload_Title' && lbl.pageName=='FileUpload').map(filteredPerson => (
                        <span>
                        {filteredPerson.keyValue}
                        </span>
                    ))}  
                    </span>
                </div> 
                <div className="fullwidth row m0">
                  <div className="  col-md-3 ">
                  
                      <div className="row col-md-12 mt-10 p0 ">                
                      {/* <Form.Control
                                              id="filetype"
                                              as="select"
                                              name="status"
                                              value={this.state.filetype}
                                              onChange={this.handleChange}
                                              aria-label='Select File'
                                              className= "ml-10"
                                          >
                                              <option value="Select File">Choose File Type</option>
                                            
                                              <option value="Sales">Sales</option>
                                              <option value="Purchases">Purchases</option>
                                              <option value="Inventry">Inventry</option>
                                              <option value="Expenses">Expenses</option>
                                              <option value="Income">Income</option>
                                              <option value="Cost Driver">Cost Driver</option>   
                        </Form.Control>  */}


                        <Select
                            value={this.state.file_type}
                            onChange={this.handleFileTypeSelectChange}
                            options={this.state.filetypes || []}
                            placeholder="Select File Type"
                            className="ml-10"
                        />

                        <Select
                            value={this.state.fileStructureName}
                            onChange={selectedOption =>
                                this.setState({
                                    ...this.state,
                                    fileStructureName: selectedOption
                                })
                            }
                            options={this.state.fileStructureNames || []}
                            placeholder="Select File Structure Name"
                            className="ml-10 mt-2"
                            isDisabled={
                                !this.state.file_type ||
                                this.state.fileStructureNames.length === 0
                            }//refer INC018
                        />
                                        
                      </div>

                      
                      


                      <div className="fullwidth row m0">
                      <div className="col-md-12 mt-10 p0">
                        <div className="drop-file-input">
                            <div className="drop-file-input__label">
                              <img src={uploadImg} alt="" />
                              <p>Drag & Drop your files here</p>
                          </div>
                          <input type="file" multiple="multiple" name="file" onChange={this.onChangeHandler}  onClick={(event)=> { 
               event.target.value = null
          }}/> 
                      </div>
                      {
                      fileList.length > 0 ? (
                          <div className="drop-file-preview">
                              <p className="drop-file-preview__title">
                                  Files ready for upload
                              </p>
                              {
                                  fileList.map((item, index) => (
                                      <div key={index} className="drop-file-preview__item">
                                          {/* <img src={ImageConfig[item.type.split('/')[1]] || ImageConfig['default']} alt="" /> */}
                                          <div className="drop-file-preview__item__info">
                                              <p className="word-wrapper">{item.name}</p>
                                              <p>{item.size}B</p>
                                          </div>
                                          <span className="drop-file-preview__item__del" onClick={() => this.fileRemove(item)}>
                                            <Icon color="error">close</Icon></span>
                                      </div>
                                  ))
                              }
                          </div>
                      ) : null
                  }                
                      </div>              
                    </div> 
                    <div className="fullwidth row m0">
                        <div className="col-md-12 mt-10 p0">                      
                                <div className="float-left mb-30">                         
                                  <Button type="button" onClick={this.onClickHandler} >
                                  {/* className= {this.state.userrole.create=='Y'?"btn btn-primary":"hidden"} */}
                                  {Labels.filter(lbl => lbl.keyPair=='FileUpload_Upload' && lbl.pageName=='FileUpload').map(filteredPerson => (
                                    <span>
                                    {filteredPerson.keyValue}
                                    </span>
                                    ))}  
                                  </Button>                           
                                    </div>  
                                    
                        </div>
                      </div> 
                  </div>
                  <div className="  offset-1 col-md-8 ">   
                        <div className="fullwidth row m0">            
                          <div  className="row col-md-12 mt-10  ml-0 p0">
                          <ReactTable
                              data={this.state.fileuploaddetails}
                              columns={this.state.columns}
                              defaultPageSize={15}
                              className="-striped -highlight fullwidth"
                          />
                          </div> 
                      </div> 
                  </div>
                </div>
            </div>
        </>
    );
                   
}
}


 